<template>
  <div style="padding: 10px;">
    <div style="margin-bottom: 20px;display: flex;flex-direction: row;">
      <div style="height: 20px;width: 3px;background:#55acee;"></div>
      <span style="line-height: 20px;margin-left: 5px;font-size: 16px;font-weight: 300;">学习路径统计</span>
    </div>
    <!-- 学习路径统计指标 -->
    <a-row>
      <a-col :span="24">
        <a-card>
          <a-row>
            <a-col :span="8">
              <a-statistic title="总阅读量" :value="trackStatistic.viewCount">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="8">
              <a-statistic title="总点赞量" :value="trackStatistic.voteCount">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="8">
              <a-statistic title="点赞率" :value="trackStatistic.voteCount / trackStatistic.viewCount * 100" :precision="2"
                suffix="%" :value-style="{ color: '#cf1322' }">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <br>
    <a-row :gutter="16">
      <a-col :span="12">
        <a-card>
          <a-row>
            <a-col :span="12">
              <a-statistic title="今日阅读" :value="trackStatistic.todayViewCount" style="margin-right: 50px">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="12">
              <a-statistic title="今日点赞" :value="trackStatistic.todayVoteCount">
                <template #suffix>
                  <like-outlined />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card>
          <a-row>
            <a-col :span="12">
              <a-statistic title="预计今日阅读" :value="trackStatistic.todayViewIncrease" :value-style="{ color: '#0000ff' }">
                <template #suffix>
                  <UserOutlined />
                </template>
              </a-statistic>
            </a-col>
            <a-col :span="12">
              <a-statistic title="预计今日阅读增长" :value="trackStatistic.todayViewIncreaseRateAbs" :precision="2" suffix="%"
                class="demo-class"
                :value-style="trackStatistic.todayViewIncreaseRate < 0 ? { color: '#3f8600' } : { color: '#cf1322' }">
                <template #prefix>
                  <arrow-down-outlined v-if="trackStatistic.todayViewIncreaseRate < 0" />
                  <arrow-up-outlined v-if="trackStatistic.todayViewIncreaseRate >= 0" />
                </template>
              </a-statistic>
            </a-col>
          </a-row>
        </a-card>
      </a-col>
    </a-row>
    <br>
    <!-- 学习路径近 30 天统计指标 -->
    <a-row>
      <a-card :style="{ width: '100%' }">
        <a-col :span="24" id="main-col-track">
          <div id="main-track" style="width: 100%;height:300px;"></div>
        </a-col>
      </a-card>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'
import axios from 'axios';
import { message } from 'ant-design-vue';

declare let echarts: any;

export default defineComponent({
  name: 'TheStatisticTrack',
  setup() {

    // 学习路径统计数据
    const trackStatistic = ref();
    trackStatistic.value = {};

    // ------------------ 学习路径 ------------------

    /**
     * 学习路径统计指标 
     */
    const getTrackStatistic = () => {

      axios.get('/report/track/statistics').then((response) => {
        const result = response.data;
        console.log('result statistic => ', result)
        if (result.code == 0 && result.message == 'success') {
          const data = result.data;
          trackStatistic.value.viewCount = data[0].viewCount;
          trackStatistic.value.voteCount = data[0].voteCount;
          trackStatistic.value.todayViewCount = data[0].viewIncrease;
          trackStatistic.value.todayVoteCount = data[0].voteIncrease;

          // 按分钟计算当前时间点，占一天的百分比
          const now = new Date();
          const nowRate = (now.getHours() * 60 + now.getMinutes()) / (60 * 24);
          // console.log(nowRate)
          trackStatistic.value.todayViewIncrease = parseInt(String(data[0].viewIncrease / nowRate));
          // todayViewIncreaseRate：今日预计增长率
          trackStatistic.value.todayViewIncreaseRate = (trackStatistic.value.todayViewIncrease - data[0].viewIncrease) / data[0].viewIncrease * 100;
          trackStatistic.value.todayViewIncreaseRateAbs = Math.abs(trackStatistic.value.todayViewIncreaseRate);
        } else {
          message.error(result.message)
        }
      });
    };

    /**
     * 学习路径近 30 天统计数据
     */
    const getTrack30DayStatistic = () => {

      axios.get('/report/track/30-statistics').then((response) => {
        const result = response.data;
        console.log('result 30 statistic => ', result)
        if (result.code == 0 && result.message == 'success') {
          const data = result.data;
          console.log('statistic data => ', data)

          initTrack30DayEcharts(data)
        } else {
          message.error(result.message)
        }
      });
    };

    /**
     * 初始化学习路径 近 30天数据
     * @param list
     */
    const initTrack30DayEcharts = (list: any) => {
      // 发布生产后出现问题：切到别的页面，再切回首页，报表显示不出来
      // 解决方法：把原来的id=main的区域清空，重新初始化
      const mainDom = document.getElementById('main-col-track');
      if (mainDom) {
        mainDom.innerHTML = '<div id="main-track" style="width: 100%;height:300px;"></div>';
      }
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.getElementById('main-track'));

      const xAxis = [];
      const seriesView = [];
      const seriesVote = [];
      for (let i = 0; i < list.length; i++) {
        const record = list[i];
        xAxis.push(record.date);
        seriesView.push(record.viewIncrease);
        seriesVote.push(record.voteIncrease);
      }

      // 指定图表的配置项和数据
      const option = {
        title: {
          text: '30天趋势图'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['总阅读量', '总点赞量']
        },
        grid: {
          left: '1%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xAxis
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '总阅读量',
            type: 'line',
            // stack: '总量', 不堆叠
            data: seriesView,
            smooth: true
          },
          {
            name: '总点赞量',
            type: 'line',
            // stack: '总量', 不堆叠
            data: seriesVote,
            smooth: true
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    };

    onMounted(() => {

      getTrackStatistic();

      getTrack30DayStatistic();

    });

    return {
      trackStatistic
    }
  }
});
</script>
<style scoped></style>
